(function () {
  var PARAM = 'view';
  var VALID = ['grid', 'list'];

  function getView() {
    var params = new URLSearchParams(window.location.search);
    var v = params.get(PARAM);
    return VALID.indexOf(v) !== -1 ? v : 'grid';
  }

  function setView(v) {
    var params = new URLSearchParams(window.location.search);
    if (v === 'grid') {
      params.delete(PARAM);
    } else {
      params.set(PARAM, v);
    }
    var qs = params.toString();
    var newUrl = window.location.pathname + (qs ? '?' + qs : '') + window.location.hash;
    window.history.replaceState(null, '', newUrl);
  }

  function applyView(view) {
    document.querySelectorAll('[data-product-grid]').forEach(function (grid) {
      grid.classList.toggle('v-grid--list', view === 'list');
      grid.classList.toggle('v-grid--grid', view === 'grid');
    });
    document.querySelectorAll('[data-grid-section]').forEach(function (sec) {
      sec.setAttribute('data-grid-state', view);
    });
  }

  function init() {
    applyView(getView());
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-view-toggle]');
      if (!btn) return;
      e.preventDefault();
      var next = getView() === 'grid' ? 'list' : 'grid';
      setView(next);
      applyView(next);
    });
    document.addEventListener('shopify:section:load', function () { applyView(getView()); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
